import React from 'react';
import { SidebarMenuItem, SidebarMenuButton } from 'src/shared/components/ui/sidebar';
import { redirectToShopify } from 'src/shared/utils/redirect';
import { ShoppingCart as ShoppingCartOutlinedIcon } from 'lucide-react';

const ShopifyMenu = () => {
    const handleClick = () => {
        redirectToShopify();
    };

    return (
        <SidebarMenuItem>
            <SidebarMenuButton tooltip='Shop' onClick={handleClick}>
                <ShoppingCartOutlinedIcon />
                <span>Shop</span>
            </SidebarMenuButton>
        </SidebarMenuItem>
    );
};

export default ShopifyMenu;
